export class EmployeeDocument{
        
    constructor(
        public DocumentType?:string,
        public DocumentoId?:number,
        public Icon?:string,
        public Date?:Date,
        public Title?:string,
        public Document?:string) {
        }
}